module.exports = __webpack_public_path__ + "static/Out-Of-Stock-Detection-1e3e2eb2cbf078a17c05323282d225ce.jpg";